var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrivateClosed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.096 7.616V5.6a3 3 0 0 0-.42-1.536q-.42-.72-1.14-1.14A3 3 0 0 0 12 2.504a3 3 0 0 0-1.536.42q-.72.42-1.14 1.14a3 3 0 0 0-.42 1.536v2.016zm-3.096 9q.816 0 1.416-.6t.6-1.416-.6-1.416-1.416-.6-1.416.6-.6 1.416.6 1.416 1.416.6m6-9q.816 0 1.416.576t.6 1.392v10.032q0 .816-.6 1.392T18 21.584H6a1.98 1.98 0 0 1-1.416-.576 1.86 1.86 0 0 1-.6-1.392V9.584q0-.816.6-1.392T6 7.616h.984V5.6q0-1.368.672-2.52A5 5 0 0 1 9.48 1.256 4.9 4.9 0 0 1 12 .584q1.368 0 2.52.672a5 5 0 0 1 1.824 1.824q.672 1.152.672 2.52v2.016z"
})));
export default SvgPrivateClosed;